class VariantCategoriesNav extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      list: this.querySelector(".variant-categories-nav__list"),
      scrollbar: this.querySelector(".variant-categories-nav__scrollbar"),
      thumb: this.querySelector(".variant-categories-nav__thumb"),
    };
    this.dragStartX = 0;
    this.dragStartScroll = 0;

    this.update = this.update.bind(this);
    this.onThumbPointerDown = this.onThumbPointerDown.bind(this);
    this.onThumbPointerMove = this.onThumbPointerMove.bind(this);
    this.onThumbPointerUp = this.onThumbPointerUp.bind(this);
    this.onTrackPointerDown = this.onTrackPointerDown.bind(this);
  }

  connectedCallback() {
    const { list, scrollbar, thumb } = this.elements;

    if (!list || !scrollbar || !thumb) return;

    list.addEventListener("scroll", this.update, { passive: true });
    thumb.addEventListener("pointerdown", this.onThumbPointerDown);
    scrollbar.addEventListener("pointerdown", this.onTrackPointerDown);

    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(list);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  // Size and position the thumb to match the list's scroll state
  update() {
    const { list, scrollbar, thumb } = this.elements;
    const maxScroll = list.scrollWidth - list.clientWidth;

    this.classList.toggle("is-overflow", maxScroll > 1);
    if (maxScroll <= 1) return;

    const trackWidth = scrollbar.clientWidth;
    const thumbWidth = Math.max((list.clientWidth / list.scrollWidth) * trackWidth, 24);
    const thumbOffset = (list.scrollLeft / maxScroll) * (trackWidth - thumbWidth);

    thumb.style.width = `${thumbWidth}px`;
    thumb.style.transform = `translateX(${thumbOffset}px)`;
  }

  // Scroll ratio between track pixels and list pixels
  getScrollRatio() {
    const { list, scrollbar, thumb } = this.elements;
    const maxScroll = list.scrollWidth - list.clientWidth;

    return maxScroll / (scrollbar.clientWidth - thumb.offsetWidth);
  }

  onThumbPointerDown(evt) {
    evt.stopPropagation();
    this.dragStartX = evt.clientX;
    this.dragStartScroll = this.elements.list.scrollLeft;

    this.elements.thumb.setPointerCapture(evt.pointerId);
    this.elements.thumb.addEventListener("pointermove", this.onThumbPointerMove);
    this.elements.thumb.addEventListener("pointerup", this.onThumbPointerUp);
    this.elements.thumb.addEventListener("pointercancel", this.onThumbPointerUp);
  }

  onThumbPointerMove(evt) {
    const delta = (evt.clientX - this.dragStartX) * this.getScrollRatio();
    this.elements.list.scrollLeft = this.dragStartScroll + delta;
  }

  onThumbPointerUp(evt) {
    this.elements.thumb.releasePointerCapture(evt.pointerId);
    this.elements.thumb.removeEventListener("pointermove", this.onThumbPointerMove);
    this.elements.thumb.removeEventListener("pointerup", this.onThumbPointerUp);
    this.elements.thumb.removeEventListener("pointercancel", this.onThumbPointerUp);
  }

  // Clicking the track jumps the thumb's center to that point
  onTrackPointerDown(evt) {
    const { list, scrollbar, thumb } = this.elements;
    const clickX = evt.clientX - scrollbar.getBoundingClientRect().left;
    const thumbLeft = clickX - thumb.offsetWidth / 2;

    list.scrollTo({ left: thumbLeft * this.getScrollRatio(), behavior: "smooth" });
  }
}

if (!customElements.get("variant-categories-nav")) {
  customElements.define("variant-categories-nav", VariantCategoriesNav);
}
